import React, { Fragment, useState } from 'react';
import MaterialIcon from '../MaterialIcon';
import DropdownItem from './DropdownItem';
import { useRouteMatch } from 'react-router-dom';

function DropdownMenu({ setModal, isListEmpty, copyToClipboard, isProductListEmpty }) {
	const [ open, setOpen ] = useState(false);
	let listEditorMatch = useRouteMatch('/lists');
	let homepageMatch = useRouteMatch('/');
	let productMatch = useRouteMatch('/products');

	const handleMoreBtnClick = () => {
		setOpen(!open);
	};

	let dropdownItems = [];

	// If on the list editor page, allow to empty the grocery list
	if (!isListEmpty() && listEditorMatch) {
		dropdownItems.push(
			<DropdownItem
				key={'reset-list'}
				handleClick={() => {
					setOpen(false);
					setModal('reset-list');
				}}
			>
				Réinitialiser
			</DropdownItem>
		);
	}

	// If on the homepage, allow to copy the grocery list to the clipboard
	if (!isListEmpty() && (homepageMatch.isExact || listEditorMatch)) {
		dropdownItems.push(
			<DropdownItem
				key={'clipboard-list'}
				handleClick={() => {
					setOpen(false);
					copyToClipboard();
				}}
			>
				Copier la liste
			</DropdownItem>
		);
	}

	// If on the products page AND the products list isn't empty, allow to empty the products list
	if (!isProductListEmpty() && productMatch) {
		dropdownItems.push(
			<DropdownItem
				key={'empty-products'}
				handleClick={() => {
					setOpen(false);
					setModal('empty-products');
				}}
			>
				Vider la liste
			</DropdownItem>
		);
	}

	// If on the products page, allow to reset the products list to the default one form the json
	if (productMatch) {
		dropdownItems.push(
			<DropdownItem
				key={'reset-products'}
				handleClick={() => {
					setOpen(false);
					setModal('reset-products');
				}}
			>
				Liste par défaut
			</DropdownItem>
		);
	}

	if (!dropdownItems.length) {
		return '';
	}

	return (
		<Fragment>
			<div className="dropdownMenu">
				<button className="moreBtn" onClick={handleMoreBtnClick}>
					<MaterialIcon>more_vert</MaterialIcon>
				</button>

				{open ? <ul className="dropdownMenu__list">{dropdownItems}</ul> : ''}
			</div>
			{open ? <div className="dropdownMenu__view" onClick={() => setOpen(false)} /> : ''}
		</Fragment>
	);
}

export default DropdownMenu;
